import { createSlice } from '@reduxjs/toolkit';
// import { getPANFromGST } from 'services/checkAccountingInvoice';
import { filterInvoiceData } from 'services/FilterInvoiceData';
import { convertStringToNumber } from 'services/utils';

// ** Initial State
const initialState = {
  data: [],
  pageData: [],
  invoiceItem: {},
  filteredData: {},
  isGstBill: null,
  isIgstApplicable: false,
  totalAccuracy: 0,
  file: { type: 'img', url: '' },
  isScan: false
};

function calculateOverallPercentage(items) {
  if (items.length === 0) return 0; // Return 0 if the array is empty

  // Calculate the sum of accuracies
  let numberOfItem = 0;
  const sumOfAccuracies = items.reduce((total, item) => {
    const accuracy = item.accuracy || 0;
    if (accuracy > 0) {
      numberOfItem++;
      return total + accuracy;
    } else {
      return total;
    }
  }, 0);

  // Calculate the overall percentage
  const overallPercentage = (sumOfAccuracies / (numberOfItem * 100)) * 100;

  return overallPercentage;
}

// ** Reducer
const billView = createSlice({
  name: 'billView',
  initialState,
  reducers: {
    setBillViewData: (state, action) => {
      const billData = action.payload;
      const filterInvoice = filterInvoiceData(billData);
      state.invoiceItem = filterInvoice.invoiceItem;
      state.data = filterInvoice.data;

      let filteredData = { ...filterInvoice.filteredData };
      const modifyName = ['SUBTOTAL', 'TAX1', 'TAX2', 'TAX3', 'TOTAL'];
      if (Object.keys(filteredData).length > 0) {
        modifyName.forEach(item => {
          filteredData[item].answer = convertStringToNumber(
            filteredData[item]?.answer || '0'
          );
        });
      }
      if (Object.values(filteredData).length > 0) {
        const allAccuracy = calculateOverallPercentage(
          Object.values(filteredData)
        );
        localStorage.setItem('invoiceAccuracy', allAccuracy);
        state.totalAccuracy = allAccuracy;
      }

      //? Set pan number from GST number
      // filteredData['TAX_PAYER_ID'].answer = getPANFromGST(
      //   filteredData['VENDOR_GST_NUMBER'].answer
      // );

      state.filteredData = filteredData;
      state.isGstBill = filterInvoice.isGstBill;
      state.isScan = true;
      state.isIgstApplicable = !filteredData['TAX1'] && !filteredData['TAX2'];
    },
    setBillViewPageData: (state, action) => {
      state.pageData = action.payload;
    },
    setScannedFile: (state, action) => {
      state.file = action.payload;
    },
    setTotalAccuracy: (state, action) => {
      state.totalAccuracy = action.payload;
    },
    setTTypeOfBill: (state, action) => {
      state.isGstBill = action.payload;
    }
  }
});

export const {
  setBillViewData,
  setBillViewPageData,
  setScannedFile,
  setTotalAccuracy,
  setTTypeOfBill
} = billView.actions;

export default billView.reducer;
